import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { Button } from '@mui/material';
import type { Lab } from 'api/labs';
import { Permission } from 'interfaces/permissionOption';
import React, { useState } from 'react';
import { usePermissions } from 'utils/usePermissions';
import { LabExternalStorageSettingsDialog } from './LabExternalStorageSettingsDialog';

interface LabExternalStorageSettingsControlProps {
  labId?: string;
  labName?: string;
  currentLabStudyDefaultSettings?: Lab['defaultStudySettings'];
}

export const LabExternalStorageSettingsControl: React.FC<LabExternalStorageSettingsControlProps> = ({
  labId,
  labName,
  currentLabStudyDefaultSettings,
}) => {
  const { hasPermission } = usePermissions();
  const [isOpen, setIsOpen] = useState(false);

  const canManageExternalStorage = hasPermission(Permission.EditLabExternalStorageProviders);
  const canEditStudyDefaults = hasPermission(Permission.EditLab);

  if (!labId || (!canManageExternalStorage && !canEditStudyDefaults)) {
    return null;
  }

  return (
    <>
      <Button variant="outlined" startIcon={<SettingsOutlinedIcon />} onClick={() => setIsOpen(true)} color="secondary">
        Lab settings
      </Button>
      {isOpen ? (
        <LabExternalStorageSettingsDialog
          labId={labId}
          labName={labName}
          currentLabStudyDefaultSettings={currentLabStudyDefaultSettings}
          canManageExternalStorage={canManageExternalStorage}
          canEditStudyDefaults={canEditStudyDefaults}
          open
          onClose={() => setIsOpen(false)}
        />
      ) : null}
    </>
  );
};
